import React from 'react'
import { browserHistory } from 'react-router'
import { Card, CardHeader, CardText } from 'material-ui/Card'
import { RaisedButton } from 'material-ui'
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import api from '../../../api'
import Create from '../../crud/create'
import ResourceDisplay from '../../resource-display'
import fields from './institution-user-fields'

class InstitutionUser extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false
    }
  }

  componentWillMount () {
    this.loadInstitutionUser()
      .then(() => {
        this.setState({ isLoaded: true })
      })
  }

  loadInstitutionUser () {
    const { userId } = this.props
    const query = {
      filters: {
        user_id: userId
      }
    }

    return api.get('admin/institution_users', { body: query })
      .then(res => res.json())
      .then(([institutionUser]) => {
        this.setState({ institutionUser })
        return institutionUser
      })
  }

  handleResourceCreated () {
    this.loadInstitutionUser()
  }

  render () {
    const { userId } = this.props
    const { isLoaded, institutionUser } = this.state

    if (!isLoaded) return null

    if (!institutionUser) {
      return (
        <Create
// @ts-ignore
          title='Add User to Institution'
          fields={fields}
          apiPath='admin/institution_users'
          successRedirectPath={`/security/users/${userId}/edit`}
          cancelRedirectPath={`/security/users/${userId}/edit`}
          onResourceCreated={() => this.handleResourceCreated()}
          buildMenuItems={() => ([])}
          resource={{ user_id: userId }}
        />
      )
    }

    return (
      <Card>
        <CardHeader title='Institution Membership' />

        <CardText>
          <Table selectable={false}>
            <TableBody displayRowCheckbox={false}>
              <TableRow>
                <TableRowColumn>
                  Institution
                </TableRowColumn>
                <TableRowColumn>
                  <ResourceDisplay
                    path='admin/institutions'
                    filters={{ id: institutionUser.institution_id }}
                    display='name'
                    link={res => `membership/institutions/${res.id}/edit`}
                  />
                </TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>
                  Account Holder
                </TableRowColumn>
                <TableRowColumn>
                  {institutionUser.is_account_holder ? 'Yes' : 'No'}
                </TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>
                  Primary Account Holder
                </TableRowColumn>
                <TableRowColumn>
                  {institutionUser.is_primary_account_holder ? 'Yes' : 'No'}
                </TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>
                  <RaisedButton
                    label='Edit'
                    primary
                    onClick={() => browserHistory.push(
                      `/membership/institution-users/${institutionUser.id}/edit`
                    )}
                  />
                </TableRowColumn>
              </TableRow>
            </TableBody>
          </Table>
        </CardText>
      </Card>
    )
  }
}

export default InstitutionUser
